// extracted by mini-css-extract-plugin
module.exports = {"Point":"Logpoint_Point__Z769b","Location":"Logpoint_Location__tArgi","CreatedByAvatar":"Logpoint_CreatedByAvatar__a9Ibk"};